<script setup lang="ts">
import Cta from '~/components/dato/Cta.vue'
import DatoSectionContainer from '~/components/dato/DatoSectionContainer.vue'
import JoinWaitListButton from '~/components/dato/Subscription/JoinWaitListButton.vue'

import type { CtasSectionFragment } from '~/graphql/generated'

type Props = CtasSectionFragment

withDefaults(defineProps<Props>(), {
  ctas: () => [],
})

function getComponentFromCta({
  __typename,
}: CtasSectionFragment['ctas'][number]) {
  switch (__typename) {
    case 'CtaRecord':
      return markRaw(Cta)
    case 'JoinWaitListCtaRecord':
      return markRaw(JoinWaitListButton)
  }
}
</script>

<template>
  <DatoSectionContainer>
    <div
      class="tw-flex tw-flex-1 tw-flex-col tw-gap-lg md:tw-flex-none md:tw-flex-row"
    >
      <component
        :is="getComponentFromCta(cta)"
        v-for="cta in ctas"
        :key="cta.id"
        v-bind="cta"
      />
    </div>
  </DatoSectionContainer>
</template>
